export Component from './components/Component';
export HomeSidebar from './components/HomeSidebar';
export reducer from './reducer';



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/index.js
 **/